import * as React from 'react';
import { SVGProps } from 'react';

const IconLaptopFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8H0v2h24v-2H13h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm17 2H4v10h16V6Z"
    />
  </svg>
);
export default IconLaptopFilledSizeM;
